export default "__VITE_ASSET__72e25c57__"